import { render, staticRenderFns } from "./SurveyCompiled.vue?vue&type=template&id=4d1871ac&"
import script from "./SurveyCompiled.vue?vue&type=script&lang=ts&"
export * from "./SurveyCompiled.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports